import { isNil } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

export const initialState = {
	sort: 'createdOn,desc',
	quickFilter: null,
	raAnalysis: [],
	checkboxStatuses: {},
	checkAllCheckbox: false,
	userSubordinates: [],
};

const reducerMap = {
	[types.CHANGE_QUICK_FILTER]: (state, { payload }) => ({
		...state,
		quickFilter: payload.type,
	}),
	[types.RESET]: () => initialState,
	[types.CHANGE_RA_ANALYSIS_CHECKED]: (state, { payload }) => {
		const { id } = payload;

		return {
			...state,
			checkboxStatuses: {
				...state.checkboxStatuses,
				[id]: !isNil(state.checkboxStatuses[id]) ? !state.checkboxStatuses[id] : true,
			},
		};
	},
	[types.CHANGE_CHECK_ALL]: (state, { payload }) => ({
		...state,
		checkAllCheckbox: payload.value,
	}),
	[types.TOGGLE_CHECK_ALL]: (state) => ({
		...state,
		checkAllCheckbox: !state.checkAllCheckbox,
	}),
	[types.SET_RA_ANALYSIS]: (state, { payload }) => {
		const { raAnalysisRecords } = payload;
		return {
			...state,
			raAnalysis: raAnalysisRecords,
		};
	},
	[types.APPEND_RA_ANALYSIS]: (state, { payload }) => {
		const { raAnalysisRecords } = payload;
		return {
			...state,
			raAnalysis: [...state.raAnalysis, ...raAnalysisRecords],
		};
	},
	[types.CHANGE_ALL_SHOWN_RECORDS_TO_CHECKED]: (state, { payload }) => {
		const { shownRaAnalysisIds } = payload;
		const updatedCheckboxStatuses = {};

		shownRaAnalysisIds.forEach((id) => {
			updatedCheckboxStatuses[id] = state.checkAllCheckbox;
		});

		return {
			...state,
			checkboxStatuses: updatedCheckboxStatuses,
		};
	},
	[types.SET_SORT]: (state, { payload }) => {
		const { sort } = payload;
		return {
			...state,
			sort,
		};
	},
	[types.SAVE_USER_SUBORDINATES]: (state, { payload }) => {
		const { userSubordinates } = payload;
		return {
			...state,
			userSubordinates,
		};
	},
};

export default handleActions(reducerMap, initialState);
